export default __webpack_public_path__ + "static/media/LogoWhite.b647973f.svg";